import { Helmet } from "react-helmet-async";
import { defaultOgImage, siteName, siteUrl } from "../content";

function Seo({ title, description, path, image, type = "website", jsonLd, noindex = false }) {
  const url = `${siteUrl}${path}`;
  const ogImage = image || defaultOgImage;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet defer={false}>
      <title>{title}</title>
      <meta content={description} name="description" />
      <link href={url} rel="canonical" />
      <meta content={noindex ? "noindex, nofollow" : "index, follow"} name="robots" />

      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={url} property="og:url" />
      <meta content={type} property="og:type" />
      <meta content={siteName} property="og:site_name" />
      <meta content={ogImage} property="og:image" />
      <meta content="1200" property="og:image:width" />
      <meta content="630" property="og:image:height" />
      <meta content="en_US" property="og:locale" />

      <meta content="summary_large_image" name="twitter:card" />
      <meta content={title} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content={ogImage} name="twitter:image" />

      {jsonLdList.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export default Seo;
